import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import axiosPrivate from '../hooks/useAxiosPrivate'
import useAuth from '../hooks/useAuth'

import NextAppointmentCard from './NextAppointmentCard'
import NextCounsellingCard from './NextCounsellingCard'
import Feature from './Feature'

const NextAppointment = () => {
  const { auth } = useAuth()

  const navigate = useNavigate()
  const axios = axiosPrivate();

  const [showNextAppointment, setShowNextAppointment] = useState(false)
  const [nextAppointments, setNextAppointments] = useState(null)
  const [nextWbaSession, setNextWbaSession] = useState(null)
  const [counsellingFlagPassed, setCounsellingFlagPassed] = useState(null)

  useEffect(() => {
    fetchLatest()
  }, [])

  useEffect(() => {
    if (counsellingFlagPassed) {
      fetchLatestWba()
    }
  }, [counsellingFlagPassed])

  const editAppointmentClicked = (appointment) => {
    navigate(`/referral/${appointment.booking_id}`, {
      state: {
        booking: appointment.booking_id, // replace with your actual data object
      },
    })
  }

  const fetchLatest = async () => {
    try {
      const response = await axios.get(
        `/bookings/next-booking/${auth?.user?.id}`,
        { local: true }
      )
      setNextAppointments(response.data.result)
      if (response.data.result.length >0) {
        setShowNextAppointment(true)
      }

    } catch (error) {
      console.error('Error fetching resources:', error)
    }
  }

  const fetchLatestWba = async () => {
    try {
      if (auth?.user?.client?.metadata?.wba_client_reference) {
        const wbaResponse = await axios.get(process.env.REACT_APP_WBA_API_URL + '/sessions/upcoming-counselling/' + auth?.user?.client?.metadata?.wba_client_reference + '?api_token=' + process.env.REACT_APP_WBA_API_KEY)
        if (wbaResponse?.data?.result?.session) {
          setNextWbaSession(wbaResponse?.data?.result?.session)
        } else {
          setNextWbaSession(null)
        }
      }
    } catch (error) {
      console.error('Error fetching resources:', error)
    }
  }

  return (
    <div className="mt-2 mb-2">
      {(showNextAppointment || nextWbaSession) &&  <h2 className="text-xl font-medium pb-4">Your Upcoming Appointments</h2>}
      <div className='flex gap-5'>
        {showNextAppointment && (
          <>
            {nextAppointments && nextAppointments?.length > 0 && (
              <div className="flex justify-start gap-8 flex-wrap">
                {nextAppointments.map((nextAppointment) => (
                  <NextAppointmentCard
                  key={nextAppointment.id}
                  appointment={nextAppointment}
                  onClick={() => editAppointmentClicked(nextAppointment)}
                  />
                ))}
              </div>
            )}
          </>
        )}
        <Feature
          featureName='counselling-v2'
          accepted={
            nextWbaSession && 
              <div className="flex justify-start gap-8 flex-wrap">
                  <NextCounsellingCard
                    session={nextWbaSession}
                    // onClick={() => editAppointmentClicked(nextAppointment)}
                  />
              </div>
          }
          onAccept={() => {
            setCounsellingFlagPassed(true)
          }}
        />
      </div>
      {!showNextAppointment && !nextWbaSession && <p>No Upcoming Appointments</p>}
    </div>
  )
}

export default NextAppointment
